export interface IHint {
  name: string;
  isVisible: boolean;
  isFocused: boolean;
  isHovered: boolean;
}

export interface IHintConfig {
  enabled: boolean;
  name: string;
  label: string;
  hint: string;
  link?: string;
  link_description?: string;
}

export enum EHintPath {
  PRODUCT = 'product',
  PROFILE = 'profile',
  NEW_PRODUCT = 'NEWPRODUCT',
}
